<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <div
      class="categories-table--subcategory-row"
      v-if="!editing"
      :key="`subcategory-info-${subcategory.id}`"
    >
      <div class="field name">
        <div class="item" @click="handleEdit()">
          <span
            class="Fuell-Text"

          >{{ subcategory.name }}
          </span>
          <img
            class="edit-icon"
            alt="icon-edit"
            :src="require('@/assets/img/icons/icon-edit.svg')"
          />

        </div>
      </div>
      <div class="field account-number">
        <div class="item" @click="handleEdit()">
          <span
            class="Fuell-Text"

          >
            {{ subcategory.accountNumber || '-' }}
          </span>
          <img
            class="edit-icon"
            alt="icon-edit"
            :src="require('@/assets/img/icons/icon-edit.svg')"
          />
        </div>

      </div>
      <div class="field tax-code">
        <div class="item" @click="handleEdit()">
          <span
            class="Fuell-Text"

          >{{ `${subcategory.taxCode ? subcategory.taxCode + '%': '-'}`}}</span>
          <img
            class="edit-icon"
            alt="icon-edit"
            :src="require('@/assets/img/icons/icon-edit.svg')"
          />

        </div>

      </div>
      <div class="field d-flex justify-content-end align-items-center" @click="handleRemove">
        <img

          class="remove-icon"
          alt="icon-edit"
          :src="require('@/assets/img/icons/close-menu.svg')"
        />

      </div>

    </div>
    <form
      class="categories-table--subcategory-row categories-table--subcategory-row--edit"
      @submit.prevent="handleSave"
      novalidate
      :key="`subcategory-info-edit-${subcategory.id}`"
      v-else
    >
      <div class="field">
        <div class="item">
          <div
            class="close-container"
            @click="handleClose()"
          >
            <span class="close-line"></span>
          </div>
          <div class="Form-field Form-field--method">
            <input
              class="input"
              :placeholder="$t('company_details_subcategory_name_field')"
              type="text"
              v-model="subcategoryModel.name"
            />
          </div>
        </div>

      </div>

      <div class="field account-number">

        <div class="item">
          <div class="Form-field">

            <input
              class="input center"
              :placeholder="$t('company_details_account_number_field')"
              type="text"
              @keypress="handleUnwantedCharacters($event)"
              v-model="subcategoryModel.accountNumber"
            />
          </div>
        </div>

      </div>
      <div class="field tax-code">

        <div class="item">
          <div class="Form-field">
            <input
              class="input"
              :placeholder="$t('company_details_tax_field')"
              type="number"
              @keypress="handleNonNumeric($event)"
              v-model="subcategoryModel.taxCode"
            />
            <span class="input-percent-sign">%</span>

          </div>
        </div>

      </div>
      <div class="field d-flex justify-content-end align-items-center">

        <button
          type="submit"
          class="button-borderless clickable"
          :class="{ blue: !$v.$invalid }"
          :disabled="$v.$invalid"
        >
          <span
            class="link"
            v-t="{ path: 'ACTION_SAVE' }"
          ></span>
        </button>

      </div>

    </form>

  </transition>

</template>

<script>

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],

  props: {
    subcategory: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      subcategoryModel: {},
      showConfirmModal: false
    }
  },
  validations: {
    subcategoryModel: {
      name: { required }
    }
  },
  created () {
    this.subcategoryModel = Object.assign({}, this.subcategory)
  },
  computed: {
    categories () {
      return this.$store.getters['CategoriesStore/categories'] || []
    }
  },
  methods: {
    handleNonNumeric (event) {
      event = event || window.event
      var charCode = event.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        event.preventDefault()
      } else {
        return true
      }
    },
    handleEdit () {
      this.$emit('edit')
    },
    handleClose () {
      this.$emit('close')
      this.$forceUpdate()
    },
    handleRemove () {
      this.$emit('removeSubcategory', this.subcategory)
      // this.showConfirmModal = true
    },
    handleUnwantedCharacters (event) {
      return ['e', 'E', '+', '-', ','].includes(event.key) && event.preventDefault()
    },
    handleSave () {
      if (!this.$v.$invalid) {
        const data = {
          name: this.subcategoryModel.name,
          accountNumber: this.subcategoryModel.accountNumber,
          taxCode: this.subcategoryModel.taxCode
        }
        if (this.subcategoryModel.id) {
          this.$store
            .dispatch('CategoriesStore/updateCustomSubcategory', {
              id: this.subcategoryModel.id,
              data
            })
            .then(() => {
              setTimeout(() => this.$emit('close'), 100)
            })
          let customCategories = []
          this.category.customCategories.forEach(item => {
            if (item.id === this.subcategoryModel.id) {
              customCategories.push({ ...item, ...this.subcategoryModel })
            } else {
              customCategories.push({ ...item })
            }
          })
          this.$set(this.category, 'customCategories', customCategories)
        } else {
          this.$store
            .dispatch('CategoriesStore/createCustomSubcategory', {
              categoryId: this.category.id,
              data
            })
            .then(() => {
              setTimeout(() => this.$emit('close'), 100)
            })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.categories-table--subcategory-row {
  display: grid;
  grid-column-gap: 8px;
  grid-template-columns: 333px 1fr 1fr 10px;
  height: 32px;
  align-items: center;
  position: relative;
  &--edit {
    grid-template-columns: 333px 75px 75px 50px;
  }
  @media screen and (max-width: 576px) {
    grid-template-columns: minmax(120px, 185px) 75px 75px 80px;

    margin: 10px 0px;
    height: 100%;
  }
  &:hover {
    .Fuell-Text {
      font-weight:400;
    }
    .remove-icon {
      opacity: 1;
      width: 8px;
      height: 8px;
      margin-left: 5px;
    }
  }
}
.edit-icon,
.remove-icon {
  opacity: 0;

  margin-left: 5px;
  transition: 150ms all ease-out;
}

.remove-icon {
  width: 8px;
  height: 8px;
}
.field {
  .item {
    display: flex;
    align-items: center;
    min-height: 32px;
    max-height: 32px;
  }
  cursor: pointer;
  span:hover {
    + .edit-icon {
      opacity: 1;
      margin-left: 6px;
    }
  }
}

.account-number,
.tax-code {
  cursor: pointer;
  input {
    max-width: 75px;
  }
}

// .account-number {
//   .input {
//     margin: 0px;
//     padding: 0px;
//   }
// }

// .tax-code {
//   .input {
//     margin: 0px -6px 0px 0px;
//   }
// }

.input {
  background-color: var(--fill-text-area);
  color: var(--text-body);
  border: 0;
  line-height: 34px;
  padding: 0 6px;
  font-weight: 300;
  border-radius: 4px;
  height: 100%;

  &::placeholder {
    font-size: 14px;
  }
}

.input-percent-sign {
  margin-left: -20px;
  display: flex;
  align-items: center;
  color: var(--text-placeholder) !important;
}
.icon--trash {
  margin: 0 6px 0 10px;
}
.close {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
}

.input::-webkit-outer-spin-button,
.input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@media screen and (max-width: 576px) {
  .categories-table--subcategory-row {
    width: 100%;
  }
  .Fuell-Button .small .blue {
    padding: 0px;
  }
  .Fuell-Button--label {
    margin: 0px;
  }
  .icon--trash {
    margin: 2px;
  }
  .input-percent-sign {
    margin-left: -30px;
  }
}

.close-container {
  width: 20px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.close-line {
  width: 10px;
  height: 2px;
  background-color: var(--text-body);
  margin-right: 8px;
  cursor: pointer;
}
.Form-field {
  display: flex;
  align-items: center;
  height: 32px;
  max-height: 32px;
  min-height: 32px;
  margin: 0px;
  padding: 0px;
}

.Form-field--method {
  width: 100%;
  input {
    width: 100%;
  }
}

.button-borderless {
  border: none;
  background-color: var(--white);
  padding: 0px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 150ms ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.field.account-number {
  .item .Fuell-Text {
    min-width:1em;

  }
}
.field.tax-code {
  .item .Fuell-Text {
    min-width:1em;

  }
}
</style>
